import { Head } from '@inertiajs/react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { Card } from '@/components/ui/Card'
import { Badge } from '@/components/ui/Badge'
import type { Breadcrumb } from '@/types/shared'

type Props = {
  practiceMatch: {
    id: string
    scheduledAt: string
    location: string | null
    notes: string | null
    isHome: boolean
    opponentName: string | null
    opponentType: 'Team' | 'School'
  }
  breadcrumbs: Breadcrumb[]
}

export default function SchoolPracticeMatchShow({ practiceMatch, breadcrumbs }: Props) {
  return (
    <AppShell>
      <Head title={`練習試合 vs ${practiceMatch.opponentName ?? ''}`} />
      <PageHeader
        title={`vs ${practiceMatch.opponentName ?? '?'}`}
        description="練習試合の詳細"
        breadcrumbs={breadcrumbs}
      />

      <Card padding="lg" className="space-y-6 max-w-3xl">
        <div className="flex items-center gap-2">
          <Badge variant={practiceMatch.isHome ? 'success' : 'outline'}>
            {practiceMatch.isHome ? 'ホーム' : 'アウェー'}
          </Badge>
        </div>
        <dl className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <Item label="日時" value={formatDateTime(practiceMatch.scheduledAt)} />
          <Item label="対戦相手" value={practiceMatch.opponentName ?? '未設定'} />
          <Item label="会場" value={practiceMatch.location ?? '未設定'} />
        </dl>
        {practiceMatch.notes ? (
          <section className="space-y-2">
            <h2 className="text-sm font-semibold text-white">備考</h2>
            <p className="whitespace-pre-line text-sm text-white/80">{practiceMatch.notes}</p>
          </section>
        ) : null}
      </Card>
    </AppShell>
  )
}

function Item({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
      <dt className="text-xs uppercase tracking-wide text-white/40">{label}</dt>
      <dd className="mt-2 text-sm text-white/80">{value}</dd>
    </div>
  )
}

function formatDateTime(value: string) {
  return new Date(value).toLocaleString('ja-JP', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    weekday: 'short',
  })
}
